import { render, staticRenderFns } from "./team-and-project-target-picker.vue?vue&type=template&id=7ca8d5ed&scoped=true"
import script from "./team-and-project-target-picker.vue?vue&type=script&lang=ts"
export * from "./team-and-project-target-picker.vue?vue&type=script&lang=ts"
import style0 from "./team-and-project-target-picker.vue?vue&type=style&index=0&id=7ca8d5ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca8d5ed",
  null
  
)

export default component.exports